<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar title="Avalicação do bolsista pelo coordenador"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-layout align-center justify-center>
                <v-flex xs12 lg8>

                  <c-selecionar-nota
                    label="Inteiração do aluno com o Plano de Trabalho a ser cumprir"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Atuação do bolsista na execução do Plano de Trabalho estabelecido"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Assiduidade"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Iniciativa"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Responsabilidade"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Capacidade de Interação com o público-atingido "
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Participação nas atividades do programa/projeto vinculado"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Integração com a equipe"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Capacidade de organização e gerenciamento de rotina"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Participação em eventos"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Desenvolver-se do ponto de vista pessoal"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Desenvolver-se do ponto de vista acadêmico."
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Adquirir novos conhecimentos"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Confrontar a formação acadêmica com a prática"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Vivenciar ações que integram ensino, pesquisa e extensão"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Vivenciar práticas político-sociais"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Perceber a inserção social de sua profissão"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Ajudar a solucionar problemas identificados"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Avaliar criticamente seu processo de formação"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Desenvolver ações multidisciplinares/interdisciplinaresInfluir na inserção de outros alunos no programa/projeto vinculado"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Influir na inserção de outros alunos no programa/projeto vinculado"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Ser autor ou co-autor de publicação ou outro produto acadêmico"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Conhecer o Plano Nacional de Extensão"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Conhecer a política de extensão da Universidade"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Adquirir capacidade de organização e gerenciamento de rotina"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Vivenciar a dinâmica de ações interinstitucionais"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <v-layout>
                    <label class="black--text" style="margin-bottom: 10px">
                      Relatório parcial de atividades desempenhada pelo bolsista no período (descrição sucinta).
                    </label>
                  </v-layout>

                  <v-layout>
                    <v-textarea
                      :rows="5"
                      multi-line
                      counter="500"
                      :rules="couterRules"
                      required
                      v-model="avaliacao.relatorio"
                      outlined
                    ></v-textarea>
                  </v-layout>

                </v-flex>
              </v-layout>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="criarBolsa" :disabled="!formularioValido">Salvar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import SelecionarNota from '@/components/c-selecionar-nota'
  import bolsas from '@/utils/bolsas'
  import { mapActions } from 'vuex'

  export default {
    data: () => ({
      formularioValido: false,
      avaliacao: {
        relatorio: ''
      },
      regrasBasicas: [
        (input) => input !== undefined || 'Este campo é obrigatório'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      criarBolsa: function () {
        console.log(this.avaliacao.nota)
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' })
      bolsas.getPermissoesUnidades()
      .then(response => {
        this.listaPermissoesUnidades = response.data.slice()
      })
      .catch(error => {
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-selecionar-nota': SelecionarNota
    }
  }
</script>



// WEBPACK FOOTER //
// avaliacao-coordenador.vue?194c817c